import styled from '@emotion/styled';
import { Button } from '@mui/material';
import colors from '../../assets/colors';

interface IProps {
	backgroundColor?: keyof typeof colors;
	size?: string;
	isBorder?: boolean;
	borderWidth?: number;
	borderColor?: keyof typeof colors;
	hover?: keyof typeof colors;
	hoverText?: keyof typeof colors;
	color?: keyof typeof colors;
	isHover?: boolean;
}

const StyledButton = styled(Button)<IProps>`
	width: ${p =>
		p.size === 'large' ? '300px' : p.size === 'small' ? '120px' : '240px'};
	height: ${p => (p.size === 'small' ? '30px' : '50px')};
	border-radius: 10px;
	&:hover {
		color: ${p =>
			p.variant === 'outlined' && p.isHover ? '#1976d2' : p.isHover && 'white'};
	}
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	StyledButton,
};
